module.exports = function(ratings) {
	'use strict'
	ratings.directive('ratingDir',ratingDir);
	ratingDir.$inject=[];
	function ratingDir() {
		return {
			template: require('./partial/edit-newrating.html'),
			controller:"ratingController",
			controllerAs:"vmrating",
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/ratingModule/edit-newrating/js/directive/ratingDirective.js
// module id = 576
// module chunks = 0